import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { Operate } from './pages/operate';
import { Store } from './pages/store';
import { Equipment } from './pages/equipment';
import { Attention } from './pages/attention';
import { Questionnaire } from './pages/questionnaire';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path='/'>
          <Operate />
        </Route>
        <Route path='/operate'>
          <Operate />
        </Route>
        <Route path='/store'>
          <Store />
        </Route>
        <Route path='/informationBase'>
          <Equipment />
        </Route>
        <Route path='/attentionMore'>
          <Attention />
        </Route>
        <Route path='/wechat'>
          <Questionnaire />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
